export default "__VITE_ASSET__f4s$MSX7__"